import React from "react";
const SidebarContext = React.createContext(null);
SidebarContext.displayName = "SidebarContext";
export default SidebarContext;
